import { useEffect, useState } from 'react';
import { getSubscriptionPlans } from '../../lib/use-cases/get-subscription-plans';
import { MK_FOUR_WEEKS_2999_ONE_WEEK_899_TRIAL_PLAN, MK_FOUR_WEEKS_2999_WITHOUT_TRIAL_PLAN, MK_TWELVE_WEEKS_5999_WITHOUT_TRIAL_PLAN } from '../../lib/shared/subscription-plans';

const DEFAULT_PLANS = [MK_FOUR_WEEKS_2999_ONE_WEEK_899_TRIAL_PLAN, MK_FOUR_WEEKS_2999_WITHOUT_TRIAL_PLAN, MK_TWELVE_WEEKS_5999_WITHOUT_TRIAL_PLAN];

function useSubscriptionPlans() {
    const [plans, setPlans] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const getData = async () => {
        const list = await getSubscriptionPlans();

        setPlans(DEFAULT_PLANS.map(plan => list.find(item => item.plan === plan)).filter(Boolean));
        setIsLoading(false);
    };

    useEffect(() => {
        getData();
    }, []);

    return {
        plans,
        isLoading
    };
}

export {
    useSubscriptionPlans
};
